<template>
  <Loading v-if="isLoading" variant="inline" transparent />
  <Alert v-else-if="errorResponse">
    {{ errorResponse }}
  </Alert>
  <div v-else class="sticky vertical">
    <table class="c-table sticky_fix">
      <thead>
        <tr>
          <th width="50%">対象月</th>
          <th width="25%">請求書</th>
          <th>決済ステータス</th>
        </tr>
      </thead>
    </table>
    <div class="sticky_scroll" :style="{ height: tableOuterH + 'px' }">
      <perfect-scrollbar
        :options="{ suppressScrollX: true, minScrollbarLength: 10 }"
        ref="scroll"
      >
        <table class="c-table" ref="table">
          <tbody>
            <tr v-if="!data.items.length">
              <td class="c-text--center" colspan="3">請求書がありません。</td>
            </tr>
            <ListItemInvoice
              v-else
              v-for="(item, index) in data.items"
              :key="index"
              :item="item"
            />
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import ListItemInvoice from '@/components/config/ListItemInvoice';
import Loading from '@/components/Loading';
import apiUsers from '@/api/users';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  components: {
    Alert,
    ListItemInvoice,
    Loading,
    PerfectScrollbar
  },

  data() {
    return {
      data: {
        items: []
      },
      errorResponse: '',
      tableMaxH: 160,
      tableOuterH: 0,
      isLoading: true
    };
  },

  created() {
    this.getInvoices();
  },

  methods: {
    getInvoices() {
      return apiUsers.me.invoices
        .get(this.auth.idToken)
        .then(response => {
          this.data.items = response.data.items;
          this.isLoading = false;
          this.setHeight();
        })
        .catch(error => {
          if (error.response) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
          this.isLoading = false;
        });
    },
    setHeight() {
      this.$nextTick(() => {
        if (!this.$refs.table) {
          return;
        }
        let tableH = this.$refs.table.clientHeight + 1;
        this.tableOuterH = Math.min(tableH, this.tableMaxH);
        if (tableH <= this.tableMaxH) {
          this.$refs.scroll.destroy();
        }
      });
    }
  }
};
</script>
